<template>
  <div
    class="inset-emoji"
    :class="{ showB: !showTop, showC: showTop }"
    v-click-outside="closeEmoji"
  >
    <div class="inset-emoji-search">
      <input class="search-input" placeholder="Search emoji" type="text" v-model="serachKey" />
      <i v-if="serachKey" class="iconfont iconclear-px" @click="serachKey = ''"></i>
      <i v-else class="iconfont iconall_view_search"></i>
    </div>
    <div class="inset-emoji-content">
      <template v-if="!serachKey">
        <ul class="emoji-types">
          <li
            v-if="recentEmojis && recentEmojis.length > 0"
            class="type-item"
            :class="{ active: activeType === 'Recent' }"
            @click="changeType('Recent')"
          >
            <el-tooltip
              content="Recent"
              popper-class="edoovo-table-cell-tooltip"
              :visible-arrow="false"
            >
              <i class="iconfont iconclock"></i>
            </el-tooltip>
          </li>
          <li
            class="type-item"
            v-for="typeItem in emojiTypes"
            :key="typeItem.key"
            :class="{ active: activeType === typeItem.key }"
            @click="changeType(typeItem.key)"
          >
            <el-tooltip
              :content="typeItem.title"
              popper-class="edoovo-table-cell-tooltip"
              :visible-arrow="false"
            >
              <svg-icon :iconClass="typeItem.icon" />
            </el-tooltip>
          </li>
        </ul>
        <div class="emoji-main">
          <div
            class="emoji-box"
            id="emojiRecent"
            type="Recent"
            v-if="recentEmojis && recentEmojis.length > 0"
          >
            <p class="emoji-title">Recent</p>
            <ul class="emoji-list">
              <li
                class="emoji-item"
                v-for="(emoji, index) in recentEmojis"
                :key="index"
                @click="handleSelect(emoji)"
              >
                <span>{{ emoji.value }}</span>
              </li>
            </ul>
          </div>
          <div
            class="emoji-box"
            v-for="typeItem in emojiTypes"
            :key="typeItem.key"
            :id="'emoji' + typeItem.key"
            :type="typeItem.key"
          >
            <p class="emoji-title">{{ typeItem.title }}</p>
            <ul class="emoji-list">
              <li
                class="emoji-item"
                v-for="(emoji, index) in emojisTemp[typeItem.key]"
                :key="index"
                @click="handleSelect(emoji)"
              >
                <span>{{ emoji.value }}</span>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <div class="emoji-result" v-else>
        <ul class="emoji-list">
          <li
            class="emoji-item"
            v-for="(emoji, index) in resultEmojis"
            :key="index"
            @click="handleSelect(emoji)"
          >
            <span>{{ emoji[0] }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import emojis from '@/assets/js/emoji'
import SvgIcon from '@/components/SvgIcon'
import { getRecentEmoji, setRecentEmoji } from '@/common/auth'

export default {
  components: { SvgIcon },
  data() {
    return {
      emojis: emojis,
      serachKey: '',
      activeType: 'Peoples',
      recentEmojis: [],
      canClose: false,
      maxRecent: 27, // 最近使用的24个Emoji
      emojiTypes: [
        {
          key: 'Peoples',
          icon: 'emoPeoples',
          title: 'Smileys & People'
        },
        {
          key: 'Nature',
          icon: 'emoNature',
          title: 'Animals & Nature'
        },
        {
          key: 'Foods',
          icon: 'emoFoods',
          title: 'Food & Drink'
        },
        {
          key: 'Activity',
          icon: 'emoActivity',
          title: 'Activity'
        },
        {
          key: 'Places',
          icon: 'emoPlaces',
          title: 'Travel & Places'
        },
        {
          key: 'Objects',
          icon: 'emoObjects',
          title: 'Objects'
        },
        {
          key: 'Symbols',
          icon: 'emoSymbols',
          title: 'Symbols'
        },
        {
          key: 'Flags',
          icon: 'emoFlags',
          title: 'Flags'
        }
      ],
      observer: null,
      canSeePeoples: false
    }
  },
  props: {
    showTop: {
      type: Boolean,
      default: true
    }
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        console.log('bind')
        function eventHandler(e) {
          if (el.contains(e.target)) {
            return false
          }
          // 如果绑定的参数是函数，正常情况也应该是函数，执行
          if (binding.value && typeof binding.value === 'function') {
            binding.value(e)
          }
        }
        // 用于销毁前注销事件监听
        el.__click_outside__ = eventHandler
        // 添加事件监听
        document.addEventListener('click', eventHandler)
      },

      unbind(el, binding, vnode) {
        console.log('unbind')

        // 移除事件监听
        document.removeEventListener('click', el.__click_outside__)
        // 删除无用属性
        delete el.__click_outside__
      }
    }
  },
  computed: {
    emojisTemp() {
      let obj = {}
      this.emojiTypes.forEach((type) => {
        if (!obj[type.key]) {
          obj[type.key] = []
        }
        this.emojis.forEach((item) => {
          if (item[1] === type.key) {
            obj[type.key].push({
              value: item[0],
              words: item[2]
            })
          }
        })
      })
      console.log('emojisTemp', obj)
      return obj
    },
    resultEmojis() {
      return emojis.filter((item) => {
        return item[2].some((word) => {
          return word.includes(this.serachKey)
        })
      })
    }
  },
  created() {
    setTimeout(() => {
      this.canClose = true
    }, 500)
    if (getRecentEmoji()) {
      this.recentEmojis = JSON.parse(getRecentEmoji())
      if (this.recentEmojis.length > 0) {
        this.activeType = 'Recent'
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 滚动监测
      this.observeScroll()
    })
  },
  beforeDestroy() {
    // observer 在 mounted 的 $nextTick 里才创建，快速开关组件时可能尚未赋值
    this.observer && this.observer.disconnect()
  },
  methods: {
    closeEmoji() {
      console.log('closeEmoji')
      if (this.canClose) {
        this.$emit('closeEmoji')
      }
      // this.$emit('closeEmoji');
    },
    observeScroll() {
      this.observer = new IntersectionObserver((changes) => {
        for (const change of changes) {
          console.log(change.intersectionRatio)
          // Ratio of intersectionRect area to boundingClientRect area
          // 目标元素的可见比例，即intersectionRect占boundingClientRect的比例，
          // 完全可见时为1，完全不可见时小于等于0
          console.log(change.target, change.target.getAttribute('type'))
          // the Element target
          // 被观察的目标元素，是一个 DOM 节点对象
          // 当前可视区域正在变化的元素
          console.log(change.isIntersecting)
          // 返回一个布尔值，下列两种操作均会触发callback：
          //1. 如果目标元素出现在root可视区，返回true。
          //2. 如果从root可视区消失，返回false
          if (change.isIntersecting) {
            this.activeType = change.target.getAttribute('type')
            // if (change.target.getAttribute('type') === 'Recent') {
            //   this.canSeeRecent = true;
            // } else
            if (change.target.getAttribute('type') === 'Peoples') {
              this.canSeePeoples = true
            }
          } else {
            if (change.target.getAttribute('type') === 'Recent') {
              if (this.canSeePeoples) {
                this.activeType = 'Peoples'
              }
            } else if (change.target.getAttribute('type') === 'Peoples') {
              this.canSeePeoples = false
            }
          }
        }
      })
      this.emojiTypes.forEach((item) => {
        let elem = document.getElementById('emoji' + item.key)
        elem && this.observer.observe(elem)
      })
      let recentElem = document.getElementById('emojiRecent')
      recentElem && this.observer.observe(recentElem)
    },
    changeType(val) {
      this.activeType = val
      document.getElementById('emoji' + val).scrollIntoView()
    },
    handleSelect(emoji) {
      console.log('handleSelect', emoji)
      this.$emit('handleSelect', emoji)

      let recents = [...this.recentEmojis]
      this.recentEmojis.forEach((item, index) => {
        if (item.value == emoji.value) {
          recents.splice(index, 1)
        }
      })
      recents.unshift(emoji)
      this.recentEmojis = recents.slice(0, this.maxRecent)
      setRecentEmoji(JSON.stringify(this.recentEmojis))
    }
  }
}
</script>

<style lang="less" scoped>
.showB {
  top: 32px !important;
}
.showC {
  top: -400px !important;
}

.inset-emoji {
  ul {
    margin: 0 !important;
    list-style: none !important;
  }

  width: 366px;
  color: #202124;
  font-family: Roboto;
  border-radius: 2px;
  height: 384px;
  padding: 12px 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  z-index: 22;
  left: -200px;
  top: 30px;
  position: absolute;

  &-search {
    height: 40px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    margin: 0 12px 12px 12px;

    .search-input {
      border: none;
      outline: none;
      font-size: 14px;
    }

    .iconfont {
      color: #5f6368;
    }

    .iconclear-px {
      cursor: pointer;
    }
  }

  &-content {
    height: calc(100% - 40px);
    overflow: hidden;

    .emoji-result {
      padding: 0 12px;
    }

    .emoji-types {
      display: flex;
      height: 30px;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 0 12px;
      list-style: none !important;

      .type-item {
        font-size: 20px;
        margin: 0 8px;
        cursor: pointer;
        color: #5f6368;
        position: relative;

        .iconfont {
          font-size: 20px;
          vertical-align: 0;
        }

        img {
          width: 1em;
          height: 1em;
          vertical-align: -0.15em;
          fill: currentColor;
          overflow: hidden;
        }

        &.active {
          color: #1a73e8;

          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 20px;
            // margin: 0 2px;
            display: block;
            height: 2px;
            background-color: #1a73e8;
          }
        }
      }
    }

    .emoji-main {
      height: calc(100% - 30px);
      padding: 0 2px 0 12px;
      overflow-y: auto;
    }

    .emoji-box {
      .emoji-title {
        font-family: Roboto-Medium;
        font-size: 12px;
        color: #5f6368;
        padding: 15px 0;
      }
    }

    .emoji-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      list-style: none !important;

      .emoji-item {
        width: 37px;
        height: 37px;
        font-size: 27px;
        margin-bottom: 8px;
        cursor: pointer;
        font-family: 'Twemoji Country Flags', 'emoji';
      }
    }
  }
}
</style>
